import Media from 'react-media';

import OtherProfilePage from 'views/DesktopViews/OtherProfilePage';
import MobileProfile from 'views/MobileViews/ProfilePage';

const OtherProfile = () => {
  return (
    <Media query="(max-width: 800px)">
      {matches => (matches ? <MobileProfile /> : <OtherProfilePage />)}
    </Media>
  );
};

export default OtherProfile;
